import * as userActions from 'domain/User/actions'
import { Navigate, useLocation } from 'react-router-dom'
import { signedInAsSelector, userModuleSelector } from 'domain/User/selectors'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { MODULES } from 'constants/modules'
import paths from 'constants/paths'
import PropTypes from 'prop-types'
import React from 'react'
import { selectors } from 'domain'

import Login from './Login'

const LoginContainer = ({
  clearSignInError,
  handleFederatedSignInRedirect,
  handleSSOSignIn,
  isSigningIn,
  signedInAs,
  setIsSigningIn,
  signIn,
  signInError,
  userModule,
}) => {
  const { search } = useLocation()
  const isSSOCallback = new URLSearchParams(search).has('code')

  // During SSO callback, show spinner immediately before Hub fires and saga sets isSigningIn
  const effectiveIsSigningIn = isSigningIn || isSSOCallback

  return signedInAs &&
    !userModule?.includes(MODULES.CARGOMATE) &&
    !userModule?.includes(MODULES.ROB) ? (
    <Navigate replace to={paths.noModuleAccess} />
  ) : (
    <Login
      clearSignInError={clearSignInError}
      handleFederatedSignInRedirect={handleFederatedSignInRedirect}
      handleSSOSignIn={handleSSOSignIn}
      isSigningIn={effectiveIsSigningIn}
      setIsSigningIn={setIsSigningIn}
      signIn={signIn}
      signInError={signInError}
    />
  )
}

LoginContainer.propTypes = {
  clearSignInError: PropTypes.func.isRequired,
  handleFederatedSignInRedirect: PropTypes.func.isRequired,
  handleSSOSignIn: PropTypes.func.isRequired,
  isSigningIn: PropTypes.bool.isRequired,
  setIsSigningIn: PropTypes.func.isRequired,
  signIn: PropTypes.func.isRequired,
  signInError: PropTypes.string,
  signedInAs: PropTypes.string,
  userModule: PropTypes.arrayOf(PropTypes.string),
}

const mapStateToProps = state => ({
  isSigningIn: selectors.isSigningInSelector(state),
  signInError: selectors.signInErrorSelector(state),
  signedInAs: signedInAsSelector(state),
  userModule: userModuleSelector(state),
})

const mapDispatchToProps = dispatch => bindActionCreators(userActions, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer)
